import { useSelector, useDispatch } from 'react-redux';
import { TableRow } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { setTransactionsParams } from '@app/store/slices/transactionsSlice';
import { theme } from '@utils/libs/theme';
import { transactionsColumns } from '@utils/tables/columns';
import {
  MemberTeamCell,
  TransactionBankCell,
  TransactionChargedCell,
  TransactionDetailsCell,
  TransactionMerchantCell,
  TransactionMobile,
  TransactionStatusCell,
} from '@widgets/tables/cells/transactions';
import { CustomTable, CustomTableMobile } from '@widgets/tables/main';

export default function TransactionsTable() {
  const dispatch = useDispatch();
  const {
    transactions,
    params,
    count_filtered,
    isLoading,
    isInitialized,
    search,
    filtersCount,
  } = useSelector((state) => state.transactions);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleSetParams = (newParams) => {
    dispatch(setTransactionsParams(newParams));
  };

  return isMobile ? (
    <CustomTableMobile
      params={params}
      setParams={handleSetParams}
      filteredCount={count_filtered || 0}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      data={transactions}
      filtersCount={filtersCount}
    >
      {transactions?.map((row) => (
        <TransactionMobile row={row} key={row.id} />
      ))}
    </CustomTableMobile>
  ) : (
    <CustomTable
      columns={transactionsColumns}
      data={transactions}
      params={params}
      setParams={handleSetParams}
      filteredCount={count_filtered || 0}
      isLoading={isLoading}
      isInitialized={isInitialized}
      search={search}
      filtersCount={filtersCount}
    >
      {transactions?.map((row) => (
        <TableRow tabIndex={-1} key={row.id}>
          <TransactionBankCell row={row} />
          <MemberTeamCell
            row={{
              owner: { name: row.user_name },
              group: row.user_group,
            }}
          />
          <TransactionDetailsCell row={row} />
          <TransactionMerchantCell row={row} />
          <TransactionStatusCell row={row} />
          <TransactionChargedCell row={row} />
        </TableRow>
      ))}
    </CustomTable>
  );
}
